import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwitchStraight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M240-440v-80h480v80H240Z" })
});
export default SvgSwitchStraight;
